import React, { useContext, useEffect, useState } from 'react'
import Container from '../../../base/Container'
import { GetRechargePlanInfoSms } from '../../../../configurations/crud/rechargeHistoryCrud'
import { DrapingRechargeSms } from './DrapingRechargeSms'
import { MdErrorOutline } from 'react-icons/md'
import { IoCheckmarkDoneCircleOutline } from 'react-icons/io5'
import { useToast } from '../../../controls/Toast/ToastService'
import useGlobalLoader from '../../../../configurations/useGlobalLoader'

export function RechargeSmsDashboard() {
    const { start, end } = useGlobalLoader()
    const [isLoadingMini, setIsLoadingMini] = useState(false)
    const [rechargeDraping, setRechargeDraping] = useState()
    const [selectedDrapingCount, setSelectedDrapingCount] = useState(100)
    const [rechargePlan, setRechargePlan] = useState(0)
    const toast = useToast()

    useEffect(() => {
        getRechargeDraping()
    }, [selectedDrapingCount])

    function getRechargeDraping() {
        setIsLoadingMini(true);
        start()
        GetRechargePlanInfoSms(selectedDrapingCount)
            .then(res => {
                if (res.data) {
                    if (res.data.result.succeeded) {
                        let hdata = res.data
                        setRechargeDraping(hdata);
                        setIsLoadingMini(false)
                        end()
                    }
                    else {
                        setIsLoadingMini(false)
                        end()
                        setRechargeDraping();
                    }
                }
                else {
                    setIsLoadingMini(false)
                    end()
                    setRechargeDraping();
                    toast.open("Recharge successfully", <IoCheckmarkDoneCircleOutline />, "success")
                }
            })
            .catch(error => {
                setIsLoadingMini(false);
                end()
                toast.open("Internet not connected, please connect and refresh", <MdErrorOutline />, "danger", 5000)

            })
    }

    const ProceedToPlan = () => {
        if (rechargeDraping.totalAmount > 0)
            setRechargePlan(4)
        else {
            toast.open("Invalid recharge amount.", <MdErrorOutline />, 'warning')
        }
    }

    return (
        <Container>
            {rechargePlan == 0 &&
                <>
                    <div className="p-6">
                        <div className="overflow-auto flex items-center justify-center">
                            <table className="rounded-md shadow hover:shadow-xl min-w-60 sm:w-full md:w-8/12 table-fixed text-sm text-gray-800 border border-gray-300">
                                <thead>
                                    <tr>
                                        <th className="w-2/3 px-4 py-3 text-left border border-gray-300">Plan Name</th>
                                        <th className="w-1/3 bg-sky-400 text-white px-4 py-3 border border-gray-300 text-center">Recharge</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    <tr className="bg-white">
                                        <td className="px-4 py-3 border border-gray-300 font-semibold">Plan</td>
                                        <td className="px-4 py-3 border border-gray-300">
                                            <select
                                                style={{ height: "33px" }}
                                                className="bg-sky-50 border w-full"
                                                value={selectedDrapingCount}
                                                onChange={(e) => setSelectedDrapingCount(e.target.value)}
                                            >
                                                <option value="100">100 SMS</option>
                                                <option value="200">200 SMS</option>
                                                <option value="300">300 SMS</option>
                                                <option value="400">400 SMS</option>
                                                <option value="500">500 SMS</option>
                                                <option value="600">600 SMS</option>
                                                <option value="700">700 SMS</option>
                                                <option value="800">800 SMS</option>
                                                <option value="900">900 SMS</option>
                                                <option value="1000">1000 SMS</option>
                                                <option value="2000">2000 SMS</option>
                                                <option value="5000">5000 SMS</option>
                                                <option value="10000">10000 SMS</option>
                                            </select>
                                        </td>
                                    </tr>

                                    {rechargeDraping && (
                                        <>
                                            <tr className="bg-gray-50">
                                                <td className="px-4 py-3 font-medium border border-gray-300">Per SMS Rate</td>
                                                <td className="px-4 py-3 border border-gray-300">₹{Number(rechargeDraping.perSmsRate).toFixed(2)}</td>
                                            </tr>
                                            <tr className="bg-white">
                                                <td className="px-4 py-3 font-medium border border-gray-300">Net Amount</td>
                                                <td className="px-4 py-3 font-medium border border-gray-300">₹{Number(rechargeDraping.netAmount).toFixed(2)}</td>
                                            </tr>
                                            <tr className="bg-gray-50">
                                                <td className="px-4 py-3 font-medium border border-gray-300">GST %</td>
                                                <td className="px-4 py-3  font-medium border border-gray-300">{rechargeDraping.gstSlab}%</td>
                                            </tr>
                                            <tr className="bg-white">
                                                <td className="px-4 py-3 font-medium border border-gray-300">GST Amount</td>
                                                <td className="px-4 py-3 font-medium border border-gray-300">₹{Number(rechargeDraping.gstAmount).toFixed(2)}</td>
                                            </tr>
                                            <tr className="font-bold text-sky-500 sm:text-lg bg-green-50 hover:bg-sky-100">
                                                <td className="px-4 py-3 border border-gray-300">Total</td>
                                                <td className="px-4 py-3 border border-gray-300">₹{Number(rechargeDraping.totalAmount).toFixed(2)}</td>
                                            </tr>
                                        </>
                                    )}

                                    {rechargeDraping?.totalAmount > 0 && (
                                        <tr className="hover:bg-gray-50">
                                            <td className="px-4 py-4 border border-gray-300"></td>
                                            <td className="px-4 py-4 border border-gray-300">
                                                <button onClick={() => ProceedToPlan()}
                                                    className="bg-sky-600 hover:bg-sky-700 text-white font-semibold px-4 py-2 rounded-lg w-full"
                                                >
                                                    Pay ₹{Number(rechargeDraping.totalAmount).toFixed(2)}
                                                </button>
                                            </td>
                                        </tr>
                                    )}
                                </tbody>
                            </table>
                        </div>
                    </div>

                </>
            }
            {rechargePlan == 4 &&
                <DrapingRechargeSms setRechargePlan={setRechargePlan} data={rechargeDraping} />
            }
        </Container>
    )
}
